


















import { Component, Vue } from 'vue-property-decorator'
import { Messages, Locations } from '../models'

@Component({})
export default class Admin extends Vue {
  Messages = Messages
  Locations = Locations

  protected addFormValues = {
    title: 'Test Form',
    content: 'This is an important message',
    start_time: '2019-02-12',
    end_time: '2019-03-12',
    // title: '',
    // content: '',
    // start_time: '',
    // end_time: '',
  }

  mounted() {
    Messages.GET_MESSAGES()
  }

  protected handleFormClick() {
    // console.log('submitting', this.addFormValues)
    // this.$store.dispatch(MessageActions.CREATE_MESSAGE, { })
  }
}
